import { GroupByMode, newTaskSuffix } from '@griply/types';
import { getHiddenLinkedItemLabels, getNewTaskPrefill } from '@griply/utils';
import React from 'react';
import { NewTaskRow } from 'shared/components/connected/new-task-row';
import {
  RenderItemProps,
  TaskListItemTypes,
} from 'shared/components/ui/virtualized-tree-list';

import { GoalHeader } from '../goal-header';
import { TreeTaskCard } from '../tree-task-card';
import { useGoalRenderData } from './goal-render-context';

export const GoalRenderItem: React.FC<RenderItemProps> = ({
  item,
  itemInstance,
  tree,
  isMultiSelectModifierPressed,
}) => {
  const {
    groupSettings,
    tasksMap,
    tasks,
    goals,
    lifeAreas,
    today,
    denseFormat,
    defaultNewTaskDate,
  } = useGoalRenderData();

  const type = item.type;

  if (type === TaskListItemTypes.Task) {
    const task = tasksMap[item.sourceId];
    if (!task) {
      return null;
    }
    const { hideLifeArea } = getHiddenLinkedItemLabels(task, groupSettings);
    return (
      <TreeTaskCard
        task={task}
        tree={tree}
        item={itemInstance}
        tasks={tasks}
        isMultiSelectModifierPressed={isMultiSelectModifierPressed}
        hideGoal
        hideLifeArea={hideLifeArea}
        displayDue={groupSettings.displayDue}
      />
    );
  }

  if (type === TaskListItemTypes.NewTask) {
    const groupSectionId = item.sourceId.replace(newTaskSuffix, '');
    const prefill = getNewTaskPrefill({
      groupByMode: GroupByMode.Goal,
      groupSectionId,
      groupSetting: groupSettings,
      today,
      defaultNewTaskDate,
    });
    return (
      <NewTaskRow
        goal={prefill.goalId}
        date={prefill.startDate}
        startTime={null}
        duration={null}
        lifeArea={prefill.lifeAreaId}
        tags={prefill.tagIds}
      />
    );
  }

  if (type === TaskListItemTypes.Goal) {
    return (
      <GoalHeader
        item={itemInstance}
        goals={goals}
        lifeAreas={lifeAreas}
        denseFormat={denseFormat}
      />
    );
  }

  return null;
};
